<template>
  <div>
    <button class="btn btn-outline-dark btn-sm w-100" @click="showConfirmationModal">
      {{ 'Cancel subscription' | translate }}
    </button>

    <div
      ref="confirmationModal"
      class="modal fade"
      id="confirmation"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <span class="modal-title" id="confirmationLabel">{{ 'Are you sure?' | translate }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            {{ explanationText | translate }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark btn-sm px-3" data-bs-dismiss="modal">
              {{ 'Cancel' | translate }}
            </button>
            <button type="button" class="btn btn-dark btn-sm px-3" @click="cancelSubscription">
              {{ 'Cancel subscription' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="surveyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="surveyModalLabel"
      aria-hidden="true"
      ref="surveyModal"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span class="modal-title" id="surveyModalLabel">{{ 'Subscription has been canceled' | translate }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            <p class="small">
              {{
                "We're sorry to see you leave. Please help us improve the platform by stating the reason why your subscription has ended"
                  | translate
              }}.
            </p>

            <div class="form-group mb-4">
              <label class="form-label small fw-medium">{{ 'Why are you canceling?' | translate }}</label>
              <div v-for="o in options" :key="o.key" class="mb-2">
                <div class="">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="cancelationReason"
                      :id="o.key"
                      :value="o.key"
                      v-model="reason"
                    />
                    <label class="form-check-label small fw-medium" :for="o.key">{{ $t(`my.${o.key}`) }}</label>
                  </div>
                </div>
              </div>
              <div v-if="['other', 'technical'].includes(reason)" class="mt-2">
                <textarea class="form-control" id="other-reason" rows="3" v-model="other_reason" :placeholder="$t('Can you tell us what happened') + '...'"></textarea>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label small fw-medium">{{ 'Would you consider returning in the future?' | translate }}</label>
              <div v-for="intent in returnIntentOptions" :key="intent.key" class="mb-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="returnIntent"
                    :id="intent.key"
                    :value="intent.key"
                    v-model="return_intent"
                  />
                  <label class="form-check-label small fw-medium" :for="intent.key">{{ $t(`my.${intent.key}`) }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark btn-sm px-3" @click="sendSurvey" :disabled="!valid_reason || locked">
              {{ 'Submit' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['explanationText', 'membershipStatus'],
  data() {
    return {
      locked: false,
      confirmationModal: null,
      surveyModal: null,
      reason: null,
      options: [
        { key: 'no_time' },
        { key: 'no_value' },
        { key: 'expensive' },
        { key: 'alternative' },
        { key: 'technical' },
        { key: 'other' },
      ],
      other_reason: null,
      return_intent: null,
      returnIntentOptions: [
        { key: 'definitely_return' },
        { key: 'maybe_return' },
        { key: 'probably_not_return' },
        { key: 'never_return' },
      ],
    }
  },
  mounted() {
    this.surveyModal = new bootstrap.Modal(this.$refs.surveyModal, {})
    this.$refs.surveyModal.addEventListener('hidden.bs.modal', (event) => {
      window.location.reload()
    })
    this.confirmationModal = new bootstrap.Modal(this.$refs.confirmationModal, {})
  },
  computed: {
    valid_reason() {
      if (this.reason === null || this.return_intent === null) {
        return false
      }

      if (['other', 'technical'].includes(this.reason)) {
        if (!this.other_reason) {
          return false
        }
        if (this.other_reason.length < 4) {
          return false
        }
      }

      return true
    },
  },
  methods: {
    cancelSubscription() {
      axios
        .post('/my/membership/cancel', {})
        .then(({ data }) => {
          if (data.membership_id) {
            this.membership_id = data.membership_id
          }
          return this.confirmationModal.hide()
        })
        .then(() => {
          if (this.membershipStatus === 'STARTED') {
            window.location.reload()
            return true
          }
          this.showSurveyModal()
        })
    },
    sendSurvey() {
      if (this.locked) {
        return false
      }
      this.locked = true
      axios
        .post('/my/membership/cancel-survey', {
          reason: this.reason,
          other_reason: this.other_reason,
          return_intent: this.return_intent,
          membership_id: this.membership_id,
        })
        .then(({ data }) => {
          this.surveyModal.hide()
        })
        .then(() => {
          setTimeout(() => {
            this.locked = false
          }, 3000)
        })
        .catch(() => {
          this.locked = false
        })
    },
    showConfirmationModal() {
      this.confirmationModal.show()
    },
    showSurveyModal() {
      this.surveyModal.show()
    },
  },
}
</script>
